import axios from '@/utils/axios';
import urlConfig from '@/utils/urlConfig';

export default {
  // ========== 商户协议配置（/pay-agr/merchant/config） ==========
  createPayAgrConfig: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/merchant/config/create', data
  ),
  submitPayAgrConfigApproval: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/merchant/config/submitApproval', data
  ),
  approvePayAgrConfig: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/merchant/config/approve', data
  ),
  pushPayAgrAgreement: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/merchant/config/pushAgreement', data
  ),
  invalidPayAgrConfig: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/merchant/config/invalid', data
  ),
  deletePayAgrConfig: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/merchant/config/delete', data
  ),
  getPayAgrConfigDetail: (configId) => axios.apiGet(
    urlConfig.busiURL + '/pay-agr/merchant/config/detail?configId=' + configId
  ),
  getPayAgrConfigList: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/merchant/config/list', data
  ),

  // ========== 支付订单（/pay-agr/order） ==========
  previewPayAgrOrder: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/order/preview', data, { 'No-Loading': 'True' }
  ),
  createPayAgrOrder: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/order/create', data
  ),
  getPayAgrOrderList: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/order/list', data
  ),
  getPayAgrOrderDetail: (orderNo) => axios.apiGet(
    urlConfig.busiURL + '/pay-agr/order/detail?orderNo=' + orderNo
  ),
  triggerPayAgrExecute: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/order/trigger/execute', data
  ),
  retryPayAgrServiceFee: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/order/retry', data
  ),

  // ========== 商户统计（/pay-agr/stat） ==========
  getPayAgrStatSummary: (params) => axios.apiGet(
    urlConfig.busiURL + '/pay-agr/stat/summary', params
  ),
  getPayAgrStatDetail: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/stat/detail', data
  ),
  exportPayAgrStat: (data) => axios.apiPost(
    urlConfig.busiURL + '/pay-agr/stat/export', data
  ),
};
